module.exports = __webpack_public_path__ + "static/media/2.a7fa0ff8.jpeg";